import camelCase from "lodash/camelCase";
import React from "react";

export const getDataTestId = (
  entityName: string,
  fieldName?: string,
  fieldLabel?: string | React.ReactNode
) => {
  const label = typeof fieldLabel === "string" ? fieldLabel : undefined;

  return camelCase([fieldName || label, entityName].filter(Boolean).join(" "));
};
